;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/officials/explore/:stateCode\",\"regex\":\"^/officials/explore/([^/]+)$\",\"paramNames\":[\"stateCode\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/auth/signin\"},{\"path\":\"/chat\"},{\"path\":\"/about\"},{\"path\":\"/errors/app\"},{\"path\":\"/officials\"},{\"path\":\"/privacy\"},{\"path\":\"/reviews\"},{\"path\":\"/rights\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.3";globalThis["_sentryRewritesTunnelPath"] = "/errors/reporting/tunnel";import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.ACTIVE_ENV,
  // Tracing is disabled (no tracesSampleRate / browserTracingIntegration)
  // to keep Sentry to error monitoring + session replay only.
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps

  // This sets the sample rate in prod and elsewhere. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate:
    process.env.ACTIVE_ENV === 'production' ? 0.005 : 1.0,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 0.01,
  integrations: [
    Sentry.httpClientIntegration(),
    Sentry.replayIntegration({
      // Mask all text content with asterisks (*). Passes text
      // content through to `maskTextFn` before sending to server.
      //
      // Defaults to true, uncomment to change
      maskAllText: false,

      // Block all media elements (img, svg, video, object,
      // picture, embed, map, audio)
      //
      // Defaults to true, uncomment to change
      // blockAllMedia: true,
      maskAllInputs: true,
    }),
  ],
  // https://docs.sentry.io/platforms/javascript/configuration/filtering
  allowUrls: [
    // Allow all URLs that contain 'localhost' or 'vercel.app'
    /localhost/,
    /vercel\.app/,
    /resist\.bot/,
    /ginrickey\.vercel\.app/,
    // Regex that matches the entire line for vercel.app and all its subdomains
    /^[^/]*\.vercel\.app\/?$/,
  ],
  ignoreErrors: [
    'Aborted is not defined', // Comes from the Yeti crawler
    "undefined is not an object (evaluating 'window.TelegramGameProxy.receiveEvent')",
  ],
});

// Sentry's Next.js integration expects this export unconditionally (it warns
// at build/runtime if missing). Without browserTracingIntegration/
// tracesSampleRate configured above, this is a no-op - no navigation spans
// are created - but exporting it silences the "ACTION REQUIRED" warning.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
